import React, { ReactElement } from 'react';
import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { PageHeading } from '../../../../components/PageHeading';
import { useVisibilityFilter } from '../../../../hooks/use-visibility-filter';
import { DemoTemplateTable } from './Table';
import { ConnectedEditDemoTemplateModal } from './Components/EditDemoTemplate/container';
import { ConnectedAddDemoTemplateModal } from './Components/AddDemoTemplate/container';

interface DemoTemplateProps {
  demoTemplates: DemoTemplate[];
  setSelectedDemoTemplate: ActionCreatorWithOptionalPayload<
    DemoTemplate | undefined,
    string
  >;
  selectedDemoTemplate?: DemoTemplate;
  isLoading: boolean;
  visibilityFilters: TemplateVisibilityValues[];
}

export function DemoTemplates({
  demoTemplates,
  isLoading,
  setSelectedDemoTemplate,
  selectedDemoTemplate,
  visibilityFilters,
}: DemoTemplateProps): ReactElement {
  const { t } = useTranslation();

  const filteredDemoTemplates = useVisibilityFilter({
    templates: demoTemplates,
    visibilityFilters,
  });

  return (
    <section className="half-padding-left">
      <PageHeading pageTitle={t('templateManager.demoTemplates.tabTitle')} />
      <div className="row flex-right">
        <DemoTemplateTable
          setSelectedDemoTemplate={setSelectedDemoTemplate}
          demoTemplates={filteredDemoTemplates}
          loading={isLoading}
        />
        {selectedDemoTemplate && selectedDemoTemplate.inventoryOnly ? (
          <ConnectedEditDemoTemplateModal />
        ) : (
          <ConnectedAddDemoTemplateModal />
        )}
      </div>
    </section>
  );
}
